import React, { ReactNode } from 'react'
import { Box, styled } from '@mui/material'
import Dashboard from '../Dashboard'
import PageLayout from '@/components/PageLayout'

const Wrapper = styled(Box)`
  width: 100%;
  max-width: 1226px;
  margin-left: auto;
  margin-right: auto;
  padding-top: 40px;
  @media (max-width: 800px) {
    padding: 24px;
  }
`

const BridgeLayout = ({ children }: { children: ReactNode }) => {
  return (
    <PageLayout>
      <Wrapper>{children}</Wrapper>
      <Box maxWidth={1240} margin={'0 auto'}>
        <Dashboard />
      </Box>
    </PageLayout>
  )
}

export default BridgeLayout
